<template>
  <v-container>
    Hello there, this is the logout page.
    If you are stuck on this page, please contact support@qwips.no.
  </v-container>
</template>


<script>
export default {
  name: 'Logout',
  props: {},
  components: {},

  data() {
    return {
    };
  },

  mounted() {
    this.$router.replace({ name: 'Home', query: { ...this.$route.query, email: this.email } });
    this.$store.dispatch('logout');
  },

  methods: {},

  computed: {
    email() {
      return this.userInfo?.EmailAdress ?? undefined;
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped></style>